// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ImageSizedByFile-module_imageWrapper__N1Lwy","contain":"ImageSizedByFile-module_contain___4XVS","image":"ImageSizedByFile-module_image__QkNdn"};